<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import { onMount } from 'svelte';
    import { get } from '../../../utils.js';
    import { storeRows, storeCreating } from './store.js';
    import { sgettext } from '../../../i18n.js';
    import EditorRow from './EditorRow.svelte';

    export let branchId = 0;
    export let activityVersionId = 0;
    export let elementVersionId = 0;
    export let elementId = 0;
    export let eevId = 0;

    export let mechanismListPlacement = 'auto';
    export let mechanismListAbsoluteParentId = undefined;
    export let mechanismListAbsoluteScrollParentSelector = undefined;

    // store to save the rows
    export let rows = [];
    $: storeRows.set([...rows]);
    $: if (Array.isArray($storeRows)) rows = [...$storeRows];

    // store to save the status of creating a row
    storeCreating.set(false);

    let energyTypesApi = `${PATH_PREFIX}/sw/api/applicable-branch-hazards-controls-grouped-by-energy-type-and-mechanism/`;
    let energyTypes = [];

    async function getEnergyTypes() {
        const response = await get(`${energyTypesApi}${branchId}/`);
        if (response.ok) {
            const result = await response.json();
            energyTypes = result;
        }
    }

    onMount(async () => {
        await getEnergyTypes();
    });

    let handleCreateNew = () => {
        storeCreating.set(true);
    }
</script>

<div class="wrapper">
    <table class='sw table mb-0 border table-hover'>
        {#if $storeRows.length != 0 || $storeCreating}
            <thead class='thead-light'>
                <tr>
                    <th colspan='2'>{sgettext('$$ENERGY_MECHANISM$$')}</th>
                    <th>{sgettext('$$RISK$$')}</th>
                    <th>{sgettext('$$CONTROL$$')}</th>
                    <th class='actions'>{sgettext('$$ACTIONS$$')}</th>
                </tr>
            </thead>
        {/if}
        <tbody>
            {#each $storeRows as row, i}
                <EditorRow
                    bind:data={row}
                    {energyTypes}
                    {branchId}
                    {activityVersionId}
                    {elementVersionId}
                    {elementId}
                    {eevId}
                    {mechanismListPlacement}
                    {mechanismListAbsoluteParentId}
                    {mechanismListAbsoluteScrollParentSelector}
                />
            {:else}
                {#if !$storeCreating}
                    <tr>
                        <td>{sgettext('$$NONE$$')}</td>
                    </tr>
                {/if}
            {/each}
            {#if $storeCreating}
                <EditorRow
                    isCreating={true}
                    {energyTypes}
                    {branchId}
                    {activityVersionId}
                    {elementVersionId}
                    {elementId}
                    {eevId}
                    {mechanismListPlacement}
                    {mechanismListAbsoluteParentId}
                    {mechanismListAbsoluteScrollParentSelector}
                />
            {/if}
        </tbody>
    </table>

    {#if !$storeCreating}
        <div class='buttons d-flex flex-nowrap justify-content-end'>
            <button class='btn btn-outline-primary' role='button' on:click={handleCreateNew}>
                {sgettext('$$CREATE_NEW_1$$')}
            </button>
        </div>
    {/if}
</div>

<style>
    .wrapper {
        margin-bottom: 15px;
    }

    th {
        width: 30%;
    }

    .actions {
        min-width: 180px;
        text-align: right;
    }

    .buttons {
        margin-top: 15px;
        text-align: right;
    }
</style>
